import { InitOptions } from "i18next";

import common_cs from "./translations/cs/common.json";
import common_en from "./translations/en/common.json";
import gamesAtMuniCs from "./translations/cs/games-at-muni.cs.md?raw";
import gamesAtMuniEn from "./translations/en/games-at-muni.en.md?raw";

export const languageConfig: InitOptions = {
    interpolation: { escapeValue: false }, // React already does escaping
    lng: "cs",
    fallbackLng: "en",
    defaultNS: "common",
    resources: {
        en: {
            common: {
                ...common_en,
                "games-at-muni": { ...common_en["games-at-muni"], content: gamesAtMuniEn },
            },
        },
        cs: {
            common: {
                ...common_cs,
                "games-at-muni": { ...common_cs["games-at-muni"], content: gamesAtMuniCs },
            },
        },
    },
};
